import type { FunctionComponent } from 'react';
import React from 'react';

import moment from 'moment';
import { forTemplate } from '@trello/i18n';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { WarningIcon } from '@trello/nachos/icons/warning';
import cx from 'classnames';

import styles from './PowerUpListingOverview.less';

const formatDeprecationMessage = forTemplate('plugin_deprecation');

export interface PowerUpListingOverviewProps {
  overview: string;
  deprecation?: {
    sunsetDate: string | null;
    infoLink: string | null;
  };
  size?: 'medium' | 'small';
}

export const PowerUpListingOverview: FunctionComponent<PowerUpListingOverviewProps> = ({
  overview,
  deprecation,
  size = 'medium',
}) => {
  const { sunsetDate, infoLink } = deprecation ?? {};

  const isDeprecationEnabled = useFeatureFlag(
    'ecosystem.pup-deprecation-field',
    false,
  );

  if (!isDeprecationEnabled || !sunsetDate) {
    return (
      <span
        className={cx({
          [styles.clampedOverview]: size === 'medium',
          [styles.clampedOverviewSmall]: size === 'small',
        })}
      >
        {overview}
      </span>
    );
  }

  const message = formatDeprecationMessage('plugin-overview', {
    sunsetDate: moment(sunsetDate).utc().subtract(1, 'day').format('LL'),
  });

  return (
    <span
      className={cx({
        [styles.overview]: size === 'medium',
        [styles.overviewSmall]: size === 'small',
      })}
    >
      <WarningIcon size="small" />
      <span>
        {message}
        {infoLink && (
          <>
            {' '}
            <a target="_blank" href={infoLink}>
              {formatDeprecationMessage('learn-more')}
            </a>
          </>
        )}
      </span>
    </span>
  );
};
